import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {hasClass, getAll, removeClass, get, addClass} = $dom

const groupSelector = '.js-filter-group'
const resetButtonSelector = '.js-reset-button'

const rangeSelector = 'data-range-from'


export default function () {
    const openResetForm = (e) => {
        const resetForm = getAll('input[type=reset]', e.target.closest(groupSelector))

        const checkIfCheckboxesFalse = () => {
            const filterInputs = getAll('input[type=checkbox]', e.target.closest(groupSelector))

            return filterInputs.some(item => item.checked)
        }

        const checkIfInputsFalse = () => {
            const filterInputs = getAll('input[type=text]', e.target.closest(groupSelector))

            return filterInputs.some(item => item.value !== '')
        }

        if (checkIfCheckboxesFalse() || checkIfInputsFalse()) {
            resetForm.forEach(item => {
                removeClass(item, variables.classNames.hidden)
            })
        } else {
            resetForm.forEach(item => {
                addClass(item, variables.classNames.hidden)
            })
        }
    }

    const handleOpenReset = () => {
        console.log(1)
    }

    const closeResetForm = (e) => {
        addClass(e.target, variables.classNames.hidden)
    }

    const handleCheckChanges = () => {
        const groupSelectors = getAll(groupSelector)

        groupSelectors.forEach(group => {
            const filterInputs = getAll('input', group)

            filterInputs.forEach(item => {
                if (hasClass(item, rangeSelector)) {
                    $events.delegate.on('input', item, openResetForm)
                } else {
                    $events.delegate.on('change', item, openResetForm)
                }
            })
        })

    }

    return new Component({
        name: 'filter',
        requiredTargets: [groupSelector],
        onInit() {
            handleCheckChanges()
            $events.delegate
                .on('click', resetButtonSelector, closeResetForm)
        },
        onDestroy() {
            $events.delegate
                .off('input', item, openResetForm)
                .off('change', item, openResetForm)
                .off('click', resetButtonSelector, closeResetForm)
        },
    })

}